/**
 * Utility function for merging CSS class names
 * Combines clsx for conditional classes with tailwind-merge for deduplication
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Combines multiple class values into a single string with Tailwind deduplication.
 * Uses clsx for conditional handling + tailwind-merge to resolve conflicts
 * (e.g. cn('px-4', 'px-2') → 'px-2')
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/**
 * Conditional class builder
 * Takes an object where keys are class names and values are boolean conditions
 */
export function cx(classMap) {
    return twMerge(Object.entries(classMap)
        .filter(([, v]) => v)
        .map(([k]) => k)
        .join(' '));
}
//# sourceMappingURL=cn.js.map